// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + chunkId + "." + {"120":"073fca3de77a67851ed4","820":"805c6a53b9dcc44bfbb4","856":"44f4dbdf0c0920801f7f"}[chunkId] + ".js";
};